import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-investing-by-risk',
  templateUrl: './investing-by-risk.component.html',
  styleUrls: ['./investing-by-risk.component.scss']
})
export class InvestingByRiskComponent implements OnInit {

  language = JSON.parse(localStorage.getItem('language'))
  
  @Input()
  clickForm: string

  @Output()
  clickOption = new EventEmitter

  @Output()
  returnTotalScore = new EventEmitter

  @Output()
  returAge = new EventEmitter

  @Output()
  completeForm = new EventEmitter

  isNewbee: boolean

  q1Score: number
  q2Score: number
  q3Score: number
  q4ScoreArray: Array<number> = []
  q4ScoreStrArray: Array<string> = []
  q4Score: number
  q5Score: number
  q6Score: number
  q7Score: number
  q8Score: number
  q9Score: number
  q10Score: number

  complete: boolean = true

  //memory user select
  q1_1: boolean = false
  q1_2: boolean = false
  q1_3: boolean = false
  q1_4: boolean = false

  q2_1: boolean = false
  q2_2: boolean = false
  q2_3: boolean = false
  q2_4: boolean = false

  q3_1: boolean = false
  q3_2: boolean = false
  q3_3: boolean = false
  q3_4: boolean = false

  q4_1: boolean = false
  q4_2: boolean = false
  q4_3: boolean = false
  q4_4: boolean = false

  q5_1: boolean = false
  q5_2: boolean = false
  q5_3: boolean = false
  q5_4: boolean = false

  q6_1: boolean = false
  q6_2: boolean = false
  q6_3: boolean = false
  q6_4: boolean = false

  q7_1: boolean = false
  q7_2: boolean = false
  q7_3: boolean = false
  q7_4: boolean = false

  q8_1: boolean = false
  q8_2: boolean = false
  q8_3: boolean = false
  q8_4: boolean = false

  q9_1: boolean = false
  q9_2: boolean = false
  q9_3: boolean = false
  q9_4: boolean = false

  q10_1: boolean = false
  q10_2: boolean = false
  q10_3: boolean = false
  q10_4: boolean = false

  q11_1: boolean = false
  q11_2: boolean = false
  q11_3: boolean = false

  q12_1: boolean = false
  q12_2: boolean = false
  q12_3: boolean = false



  totalScore: number
  age: string

  flag: any

  constructor() { }

  ngOnInit() {
    
    this.flag = localStorage.getItem("language_flag")

    if (this.clickForm === 'มือใหม่') {
      this.isNewbee = true
    } else {
      this.isNewbee = false
    }

    if (sessionStorage.getItem('userScore') != null) {
      // this.totalScore = parseInt(sessionStorage.getItem('userScore'))
      if (sessionStorage.getItem('q1') == '1') {
        this.q1_1 = true
        this.q1Score = 1
      } else if (sessionStorage.getItem('q1') == '2') {
        this.q1_2 = true
        this.q1Score = 2
      } else if (sessionStorage.getItem('q1') == '3') {
        this.q1_3 = true
        this.q1Score = 3
      } else if (sessionStorage.getItem('q1') == '4') {
        this.q1_4 = true
        this.q1Score = 4
      }

      if (this.q1Score == 1) {
        this.age = this.language.investingbyriskq1answer1
      } else if (this.q1Score == 2) {
        this.age = this.language.investingbyriskq1answer2
      } else if (this.q1Score == 3) {
        this.age = this.language.investingbyriskq1answer3
      } else if (this.q1Score == 4) {
        this.age = this.language.investingbyriskq1answer4
      }

      if (sessionStorage.getItem('q2') == '1') {
        this.q2_1 = true
        this.q2Score = 1
      } else if (sessionStorage.getItem('q2') == '2') {
        this.q2_2 = true
        this.q2Score = 2
      } else if (sessionStorage.getItem('q2') == '3') {
        this.q2_3 = true
        this.q2Score = 3
      } else if (sessionStorage.getItem('q2') == '4') {
        this.q2_4 = true
        this.q2Score = 4
      }

      if (sessionStorage.getItem('q3') == '1') {
        this.q3_1 = true
        this.q3Score = 1
      } else if (sessionStorage.getItem('q3') == '2') {
        this.q3_2 = true
        this.q3Score = 2
      } else if (sessionStorage.getItem('q3') == '3') {
        this.q3_3 = true
        this.q3Score = 3
      } else if (sessionStorage.getItem('q3') == '4') {
        this.q3_4 = true
        this.q3Score = 4
      }

      let Q4 = JSON.parse(sessionStorage.getItem('q4'))
      if (Q4 != null) {
        Q4.forEach(element => {
          if (element == 1) {
            this.q4_1 = true
          } else if (element == 2) {
            this.q4_2 = true
          } else if (element == 3) {
            this.q4_3 = true
          } else if (element == 4) {
            this.q4_4 = true
          }
          this.q4ScoreArray.push(element)
        });

      }


      if (sessionStorage.getItem('q5') == '1') {
        this.q5_1 = true
        this.q5Score = 1
      } else if (sessionStorage.getItem('q5') == '2') {
        this.q5_2 = true
        this.q5Score = 2
      } else if (sessionStorage.getItem('q5') == '3') {
        this.q5_3 = true
        this.q5Score = 3
      } else if (sessionStorage.getItem('q5') == '4') {
        this.q5_4 = true
        this.q5Score = 4
      }

      if (sessionStorage.getItem('q6') == '1') {
        this.q6_1 = true
        this.q6Score = 1
      } else if (sessionStorage.getItem('q6') == '2') {
        this.q6_2 = true
        this.q6Score = 2
      } else if (sessionStorage.getItem('q6') == '3') {
        this.q6_3 = true
        this.q6Score = 3
      } else if (sessionStorage.getItem('q6') == '4') {
        this.q6_4 = true
        this.q6Score = 4
      }

      if (sessionStorage.getItem('q7') == '1') {
        this.q7_1 = true
        this.q7Score = 1
      } else if (sessionStorage.getItem('q7') == '2') {
        this.q7_2 = true
        this.q7Score = 2
      } else if (sessionStorage.getItem('q7') == '3') {
        this.q7_3 = true
        this.q7Score = 3
      } else if (sessionStorage.getItem('q7') == '4') {
        this.q7_4 = true
        this.q7Score = 4
      }

      if (sessionStorage.getItem('q8') == '1') {
        this.q8_1 = true
        this.q8Score = 1
      } else if (sessionStorage.getItem('q8') == '2') {
        this.q8_2 = true
        this.q8Score = 2
      } else if (sessionStorage.getItem('q8') == '3') {
        this.q8_3 = true
        this.q8Score = 3
      } else if (sessionStorage.getItem('q8') == '4') {
        this.q8_4 = true
        this.q8Score = 4
      }

      if (sessionStorage.getItem('q9') == '1') {
        this.q9_1 = true
        this.q9Score = 1
      } else if (sessionStorage.getItem('q9') == '2') {
        this.q9_2 = true
        this.q9Score = 2
      } else if (sessionStorage.getItem('q9') == '3') {
        this.q9_3 = true
        this.q9Score = 3
      } else if (sessionStorage.getItem('q9') == '4') {
        this.q9_4 = true
        this.q9Score = 4
      }

      if (sessionStorage.getItem('q10') == '1') {
        this.q10_1 = true
        this.q10Score = 1
      } else if (sessionStorage.getItem('q10') == '2') {
        this.q10_2 = true
        this.q10Score = 2
      } else if (sessionStorage.getItem('q10') == '3') {
        this.q10_3 = true
        this.q10Score = 3
      } else if (sessionStorage.getItem('q10') == '4') {
        this.q10_4 = true
        this.q10Score = 4
      }

      if (sessionStorage.getItem('q11') == '1') {
        this.q11_1 = true
      } else if (sessionStorage.getItem('q11') == '2') {
        this.q11_2 = true
      } else if (sessionStorage.getItem('q11') == '3') {
        this.q11_3 = true
      }

      if (sessionStorage.getItem('q12') == '1') {
        this.q12_1 = true
      } else if (sessionStorage.getItem('q12') == '2') {
        this.q12_2 = true
      } else if (sessionStorage.getItem('q12') == '3') {
        this.q12_3 = true
      }
    }



  }

  setQuestionOneScore(event) {
    this.q1Score = event
    sessionStorage.setItem('q1', event)
    if (this.q1Score == 1) {
      this.age = this.language.investingbyriskq1answer1
    } else if (this.q1Score == 2) {
      this.age = this.language.investingbyriskq1answer2
    } else if (this.q1Score == 3) {
      this.age = this.language.investingbyriskq1answer3
    } else if (this.q1Score == 4) {
      this.age = this.language.investingbyriskq1answer4
    }

  }

  setQuestionTwoScore(event) {
    this.q2Score = event
    sessionStorage.setItem('q2', event)
  }

  setQuestionThreeScore(event) {
    this.q3Score = event
    sessionStorage.setItem('q3', event)
  }

  setQuestionFourScore(event) {

    let index = this.q4ScoreArray.indexOf(event)
    if (index == -1) {
      this.q4ScoreArray.push(event)
    }
    if (index > -1) {
      this.q4ScoreArray.splice(index, 1)
    }

    let indexStr = this.q4ScoreStrArray.indexOf(event.toString())
    if (indexStr == -1) {
      this.q4ScoreStrArray.push(event.toString())
    }
    if (indexStr > -1) {
      this.q4ScoreStrArray.splice(index, 1)
    }

    sessionStorage.setItem('q4', JSON.stringify(this.q4ScoreArray))
  }

  setQuestionFiveScore(event) {
    this.q5Score = event
    sessionStorage.setItem('q5', event)

  }

  setQuestionSixScore(event) {
    this.q6Score = event
    sessionStorage.setItem('q6', event)
  }

  setQuestionSevenScore(event) {
    this.q7Score = event
    sessionStorage.setItem('q7', event)
  }

  setQuestionEightScore(event) {
    this.q8Score = event
    sessionStorage.setItem('q8', event)
  }

  setQuestionNineScore(event) {
    this.q9Score = event
    sessionStorage.setItem('q9', event)
  }

  setQuestionTenScore(event) {
    this.q10Score = event
    sessionStorage.setItem('q10', event)
  }

  setQuestionElevenScore(event) {
    sessionStorage.setItem('q11', event)
  }

  setQuestionTwelveScore(event) {
    sessionStorage.setItem('q12', event)
  }

  sumScore() {
    this.totalScore = 0
    this.q4Score = Math.max.apply(null, this.q4ScoreArray)

    this.totalScore += this.q1Score;
    this.totalScore += this.q2Score;
    this.totalScore += this.q3Score;
    this.totalScore += this.q4Score;
    this.totalScore += this.q5Score;
    this.totalScore += this.q6Score;
    this.totalScore += this.q7Score;
    this.totalScore += this.q8Score;
    this.totalScore += this.q9Score;
    this.totalScore += this.q10Score;

  }

  xxxFormClick(menuClick) {
    event.preventDefault()
    if (this.q1Score != undefined && this.q2Score != undefined && this.q3Score != undefined && this.q4ScoreArray.length > 0 && this.q5Score != undefined &&
      this.q6Score != undefined && this.q7Score != undefined && this.q8Score != undefined && this.q9Score != undefined && this.q10Score != undefined) {
      this.sumScore()
      this.complete = true
      sessionStorage.setItem('userScore', this.totalScore.toString())
      this.returnTotalScore.emit(this.totalScore)
      this.returAge.emit(this.age)
      this.clickOption.emit(menuClick)
      this.completeForm.emit(true)
    } else if (this.q1Score == undefined || this.q2Score == undefined || this.q3Score == undefined || this.q4ScoreArray.length == 0 || this.q5Score == undefined ||
      this.q6Score == undefined || this.q7Score == undefined || this.q8Score == undefined || this.q9Score == undefined || this.q10Score == undefined) {
      this.complete = false
      this.completeForm.emit(false)
    }
    // console.log("this.age ", this.age);
  }

}
